import { useState } from 'react';
import { ALL_DURUMLAR, ALL_KAYNAKLAR, durumColors, sourceColors } from '../../../mocks/leads';

export default function Ayarlar() {
  const [waTemplate, setWaTemplate] = useState(
    'Merhaba {ad_soyad}, franchise lansmanımıza özel davet edildiniz! Detaylar için: {link}'
  );
  const [reminderTemplate, setReminderTemplate] = useState(
    'Merhaba {ad_soyad}, lansmanımız yaklaşıyor! Yerinizi ayırtmayı unutmayın.'
  );
  const [lansmanLink, setLansmanLink] = useState('https://franchise.example.com/lansman-2026');
  const [saved, setSaved] = useState(false);

  function handleSave() {
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-bold text-white">Ayarlar</h1>
        <p className="text-white/30 text-sm mt-0.5">Sistem yapılandırması ve şablonlar</p>
      </div>

      <div className="max-w-3xl space-y-5">
        {/* WhatsApp Templates */}
        <div className="rounded-xl bg-white/[0.03] border border-white/[0.07] p-6 space-y-5">
          <div className="flex items-center gap-2 mb-1">
            <i className="ri-whatsapp-line text-[#25d366]" />
            <p className="text-white font-semibold text-sm">WhatsApp Şablonları</p>
          </div>

          <div className="space-y-2">
            <label className="text-white/40 text-xs font-semibold uppercase tracking-wider">Davet Mesajı Şablonu</label>
            <textarea value={waTemplate} onChange={(e) => setWaTemplate(e.target.value.slice(0, 500))}
              rows={3} maxLength={500}
              className="w-full bg-white/[0.04] border border-white/[0.08] rounded-lg px-4 py-3 text-white/70 text-sm focus:outline-none focus:border-amber-500/50 resize-none" />
            <p className="text-white/20 text-xs">Değişkenler: {'{ad_soyad}'}, {'{link}'}, {'{telefon}'}</p>
          </div>

          <div className="space-y-2">
            <label className="text-white/40 text-xs font-semibold uppercase tracking-wider">Hatırlatma Şablonu</label>
            <textarea value={reminderTemplate} onChange={(e) => setReminderTemplate(e.target.value.slice(0, 500))}
              rows={3} maxLength={500}
              className="w-full bg-white/[0.04] border border-white/[0.08] rounded-lg px-4 py-3 text-white/70 text-sm focus:outline-none focus:border-amber-500/50 resize-none" />
          </div>

          <div className="space-y-2">
            <label className="text-white/40 text-xs font-semibold uppercase tracking-wider">Lansman Linki</label>
            <input value={lansmanLink} onChange={(e) => setLansmanLink(e.target.value)}
              className="w-full bg-white/[0.04] border border-white/[0.08] rounded-lg px-4 py-2.5 text-white/70 text-sm focus:outline-none focus:border-amber-500/50" />
          </div>
        </div>

        {/* Status Management */}
        <div className="rounded-xl bg-white/[0.03] border border-white/[0.07] p-6">
          <div className="flex items-center gap-2 mb-4">
            <i className="ri-checkbox-circle-line text-amber-400" />
            <p className="text-white font-semibold text-sm">Durum Yönetimi</p>
          </div>
          <div className="flex flex-wrap gap-2">
            {ALL_DURUMLAR.map((d) => (
              <div key={d} className="flex items-center gap-2 px-3 py-2 rounded-lg border"
                style={{ background: durumColors[d] + '12', borderColor: durumColors[d] + '30' }}>
                <span className="w-2 h-2 rounded-full" style={{ background: durumColors[d] }} />
                <span className="text-xs font-semibold" style={{ color: durumColors[d] }}>{d}</span>
              </div>
            ))}
          </div>
          <p className="text-white/20 text-xs mt-3">Durum renkleri ve sıraları sistem tarafından yönetilmektedir.</p>
        </div>

        {/* Source Management */}
        <div className="rounded-xl bg-white/[0.03] border border-white/[0.07] p-6">
          <div className="flex items-center gap-2 mb-4">
            <i className="ri-share-line text-amber-400" />
            <p className="text-white font-semibold text-sm">Kaynak Yönetimi</p>
          </div>
          <div className="flex flex-wrap gap-2">
            {ALL_KAYNAKLAR.map((k) => (
              <div key={k} className="flex items-center gap-2 px-3 py-2 rounded-lg border"
                style={{ background: sourceColors[k] + '12', borderColor: sourceColors[k] + '30' }}>
                <span className="w-2 h-2 rounded-full" style={{ background: sourceColors[k] }} />
                <span className="text-xs font-semibold" style={{ color: sourceColors[k] }}>{k}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Save */}
        <div className="flex items-center gap-3">
          <button onClick={handleSave}
            className="px-6 py-2.5 rounded-lg bg-amber-500 hover:bg-amber-400 text-black text-sm font-bold transition-all cursor-pointer whitespace-nowrap">
            <i className="ri-save-line mr-2" />Ayarları Kaydet
          </button>
          {saved && (
            <span className="flex items-center gap-1.5 text-emerald-400 text-sm font-semibold">
              <i className="ri-check-line" />Kaydedildi!
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
